<template>
    <div class="head">
        <div class="logo-mobile">
            <img src="../assets/logo.png" class="img-logo">
            <div>
                <h1>Ponto de Equilibrio</h1>
                <h2>Entre a Cruz e a Espada</h2>
            </div>
        </div>
        <div class="logo">
            <h1>Gerencie </h1>
        </div>
        <figure class="profile">
            <figcaption>
                <h2>{{nomeUsuario}}</h2>
                <h3>Empresa Exemplo</h3>
                <button  @click="logout()">Sair</button>
            </figcaption>                    
            <img src="./../assets/profile.png" alt="">

        </figure>
    </div>
</template>

<script>
export default {
  data: () => ({
      nomeUsuario: ''
  }),
  methods: {
    logout(){
        localStorage.removeItem('usuarioLogado');    
        localStorage.removeItem('codusuarioLogado'); 
    
        this.$router.push('/login');
        window.location.reload();        
    }  
    
  },
  mounted() {
      

    
  },  
  created(){
    this.nomeUsuario = localStorage.getItem('nomeUsuarioLogado');

  }
}
</script>

<style>

</style>